import { render } from "./ProductTemplate.vue?vue&type=template&id=129e634d&scoped=true"
import script from "./ProductTemplate.vue?vue&type=script&lang=js"
export * from "./ProductTemplate.vue?vue&type=script&lang=js"

import "./ProductTemplate.vue?vue&type=style&index=0&id=129e634d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129e634d"]])

export default __exports__